import { CardSkeleton } from "@/shared/ui/loading/CardSkeleton";
import { cn } from "@/shared/lib/utils/cn";

interface LoadingCardsGridProps {
  count?: number;
  variant?: "agent" | "connection";
  className?: string;
  /** `grid` for agent cards, `stack` for the connections two-column list. */
  layout?: "grid" | "stack";
}

export function LoadingCardsGrid({
  count = 9,
  variant = "agent",
  layout = "grid",
  className,
}: LoadingCardsGridProps) {
  return (
    <div
      className={cn(
        layout === "stack"
          ? "grid grid-cols-1 gap-3 xl:grid-cols-2"
          : "grid gap-4 md:grid-cols-2 lg:grid-cols-3",
        className,
      )}
    >
      {Array.from({ length: count }, (_, index) => (
        <CardSkeleton key={index} variant={variant} />
      ))}
    </div>
  );
}
